export const BIGNUMBER_SEPARATOR = ' ';
